/* Psalm 127:1-2
As die HERE die huis nie bou nie, tevergeefs werk die wat daaraan bou;
as die HERE die stad nie bewaar nie, tevergeefs waak die wagter.
Tevergeefs dat julle vroeg opstaan, laat opbly, brood van smarte eet —
net so goed gee Hy dit aan sy beminde in die slaap! */

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.css';                        // Order matters: Bootstrap's CSS must import before main.css
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;                      // Keeps the 4 `new bootstrap.Modal()` calls working

import global from './shared/utils/global.js';

import { validateToken, getUserData } from './modules/auth/views/login/auth.api.js';
import { displayError } from './shared/utils/statushandler.js';
import { showSplash } from './modules/auth/views/splash/splash.js';
import { handleAuthentication } from './modules/auth/views/login/authhandler.js';
import { onlineConnection } from './shared/utils/connectionhandler.js';
import { initialiseSensorSearch } from './modules/units/generalinfo/views/generalinfosearch.js';
import { handleUserRole } from './modules/users/views/userHandler.js';

import { initTyreManagement } from './modules/units/tyres/tyre-management.js';

initTyreManagement();

const openSignOutModal = () => {

  const signOutModal = new bootstrap.Modal(document.getElementById('signoutmodal'), {});
  signOutModal.show();
  const signOutButton = document.getElementById('signoutbutton');
  signOutButton.onclick = () => {

    if (global.mainIntervalId) {
      clearInterval(global.mainIntervalId);
    }

    if (global.detailIntervalId) {
      clearInterval(global.detailIntervalId);
    }

    localStorage.clear();
    sessionStorage.clear();

    signOutModal.hide();

    setTimeout(() => {
      window.location.reload(); // Just this one is fine
    }, 1000); // Delay so storage clear completes

  };
};

const getVersion = () => {

  const currentVersion = "2.5.13";
  const previousVersion = localStorage.getItem("version-d");

  if (previousVersion) {
    if (`PressureTrack v${currentVersion}` !== previousVersion) {
      localStorage.setItem("version-d", `PressureTrack v${currentVersion}`);
      location.reload(true);
    }
  } else {
    localStorage.setItem("version-d", `PressureTrack v${currentVersion}`);
    location.reload(true);
  }

  document.getElementById('version').innerText = `version ${currentVersion}`;

  return currentVersion;
};

const loadApp = async () => {
  try {

    const userData = getUserData();
    if (!userData) {
      displayError('User data not found. Please log in again.');
      return;
    }
    const { eMail, userRole, parentCustomerId } = userData;

    global.userRole = userRole;
    global.parentCustomerId = parentCustomerId;
    global.customerId = parentCustomerId;

    const userButton = document.getElementById('users');
    const userMenu = document.getElementById('usermenu');

    if (!userButton || !userMenu) return;

    // Toggle on button click
    userButton.addEventListener('click', (e) => {
      e.stopPropagation();             // don't bubble to document
      userMenu.classList.toggle('show');
    });

    // Close when clicking anywhere else
    document.addEventListener('click', () => {
      userMenu.classList.remove('show');
    });

    // Optional: prevent clicks inside menu from closing it immediately
    userMenu.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    const user = document.getElementById('currentuser');
    user.textContent = `${eMail}`;

    const searchInput = document.getElementById('sensor-search');
    const toggleSearchBtn = document.getElementById('toggle-search');

    toggleSearchBtn.addEventListener('click', () => {
      const isVisible = searchInput.style.display === 'inline-block';
      if (isVisible) {
        searchInput.style.display = 'none';
      } else {
        initialiseSensorSearch(parentCustomerId);
        searchInput.style.display = 'inline-block';
        searchInput.focus();
      }
    });

    handleUserRole(userRole, parentCustomerId);

    const signOutItem = document.getElementById('signout');
    if (!signOutItem) {
      console.warn('Element with ID "signOut" not found.');
      return;
    }
    signOutItem.onclick = (e) => {
      e.stopImmediatePropagation();
      openSignOutModal();
    };

    const mainContainer = document.getElementById('maincontainer');
    if (mainContainer) mainContainer.style.display = 'block';

    //Show only 'cusomter hierarchy'
    const unitsContainer = document.getElementById('unitscontainer');
    if (unitsContainer) unitsContainer.style.display = 'none';

    const splash = document.getElementById('splash');
    if (splash) splash.style.display = 'none';

  } catch (error) {
    console.error('Error loading app:', error);
    displayError('Failed to load the application. Please try again.');
  }
};

const hideLoginAppSections = () => {
  const sectionsToHide = ['splashcontainer', 'maincontainer'];
  sectionsToHide.forEach(id => {
    const element = document.getElementById(id);
    if (element) element.style.display = 'none';
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  let customerToken = validateToken();
  const version = getVersion();
  if (customerToken?.valid) {
    showSplash(customerToken, version);
    await loadApp();
  } else {
    hideLoginAppSections();
    customerToken = await handleAuthentication();
    if (customerToken) {
      setTimeout(async () => {
        showSplash(customerToken, version);
        // Wait for local storage to be ready before loading the app
        let retries = 0;
        while (!localStorage.getItem("userData") && retries < 10) {
          console.log(`Waiting for local storage... Retry ${retries + 1}/10`);
          await new Promise((resolve) => setTimeout(resolve, 500));
          retries++;
        }
        loadApp();
      }, 1500);
    }
  }
});

async function login(siteType) {
  try {
    document.getElementById('login').addEventListener('submit', async function (event) {
      event.preventDefault();

      const emailAddress = document.getElementById('username').value;
      const emailSent = await sendLoginMail(emailAddress, siteType);

      if (emailSent.success) {
        const loginForm = document.getElementById('login');
        if (loginForm) loginForm.style.display = 'none';
        const emailSentSection = document.getElementById('email-sent');
        if (emailSentSection) emailSentSection.style.display = 'block';
      } else {
        alert('Something went wrong. Try again!');
      }
    });
  } catch (e) {
    displayError('Login failed. Please try again.');
  }
}

function toggleVerifySection(showVerify) {
  const verifySection = document.getElementById('verify');

  //if (emailSentSection) emailSentSection.style.display = showVerify ? 'none' : 'block';
  if (verifySection) verifySection.style.display = showVerify ? 'block' : 'none';
}

export function logStatus(logText) {

  const onlineStatus = document.getElementById('appstatus');
  const onlineStatusDiv = document.createElement('div');
  onlineStatusDiv.className = 'appstatus offline';

  const spanTime = document.createElement('span');
  spanTime.innerText = `[${new Date().toLocaleTimeString()} - ${global.currentView}] `;

  const spanOnlineStatus = document.createElement('span');
  spanOnlineStatus.innerText = logText;
  onlineStatusDiv.appendChild(spanTime);
  onlineStatusDiv.appendChild(spanOnlineStatus);

  onlineStatus.appendChild(onlineStatusDiv);

  return;
}

// const clearStorage = () => {
//   // localStorage.removeItem("customer");
//   // localStorage.removeItem("e-mail");
//   // localStorage.removeItem("role");
//   // localStorage.removeItem("token");
//   localStorage.removeItem("userData");
//   localStorage.removeItem("version-d");
//   localStorage.removeItem("version-m");
// };
